import { useMemo, useState } from "react";
import { Tooltip } from "@mui/material";
import { MaxBrandIcon, TelegramBrandIcon } from "./MessengerBrandIcons";
import { getGroupShareLink } from "../utils/messengers";
import { useMessengerBotUsernames } from "../hooks/useMessengerBotUsernames";
import { markShareLinkCopied } from "../utils/launchReadiness";

const SHARE_CHANNELS = [
  { id: "telegram", label: "Telegram", Icon: TelegramBrandIcon },
  { id: "max", label: "MAX", Icon: MaxBrandIcon },
];

export default function ProjectCardShareActions({ gameId, isPublished }) {
  const [copiedId, setCopiedId] = useState(null);
  const { telegramBotUsername, maxBotUsername } = useMessengerBotUsernames();

  const shareLinks = useMemo(() => {
    if (!gameId) return [];

    return SHARE_CHANNELS.map(({ id, label }) => ({
      id,
      label,
      link: getGroupShareLink(
        gameId,
        id,
        id === "telegram" ? telegramBotUsername : maxBotUsername,
      ),
    }));
  }, [gameId, telegramBotUsername, maxBotUsername]);

  const handleCopy = async (event, item) => {
    event.preventDefault();
    event.stopPropagation();

    if (!isPublished || !item.link) {
      return;
    }

    try {
      await navigator.clipboard.writeText(item.link);
      markShareLinkCopied(gameId);
      setCopiedId(item.id);
      setTimeout(() => setCopiedId(null), 2000);
    } catch (error) {
      console.error("Failed to copy share link:", error);
    }
  };

  const stopCardNavigation = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <div
      className="app-project-card__actions"
      onClick={stopCardNavigation}
      onPointerDown={stopCardNavigation}
    >
      {shareLinks.map((item) => {
        const ChannelIcon = SHARE_CHANNELS.find((channel) => channel.id === item.id)?.Icon;
        if (!ChannelIcon) return null;

        const isCopied = copiedId === item.id;
        let tooltipTitle = isPublished
          ? `Скопировать ссылку для ${item.label}`
          : "Опубликуйте проект, чтобы скопировать ссылку";

        if (isCopied) {
          tooltipTitle = "Ссылка скопирована";
        }

        return (
          <Tooltip key={item.id} title={tooltipTitle} placement="top">
            <span className="app-project-card__share-wrap">
              <button
                type="button"
                className={`app-project-card__share-btn${
                  isPublished ? "" : " app-project-card__share-btn--disabled"
                }${isCopied ? " app-project-card__share-btn--copied" : ""}`}
                disabled={!isPublished}
                aria-label={tooltipTitle}
                onClick={(event) => handleCopy(event, item)}
              >
                <ChannelIcon size={22} title={item.label} />
              </button>
            </span>
          </Tooltip>
        );
      })}
    </div>
  );
}
